import { Control, Controller, FieldErrors } from "react-hook-form";
import { Row, Spacer, TwoColGrid } from "../../components/Layout/Layout";
import {
  validateEmergencyPhoneNumberIfExists,
  validatePhoneNumberIfExists,
} from "../../core/helpers/validation";
import TextInput from "../../ui-lib/components/Inputs/TextInput";
import useTranslations from "../../core/i18n/useTranslations";
import { IOrganizationDetails } from "../../core/api/organizations/types";

export const TelephonesRow = ({
  control,
  errors,
}: {
  control: Control<IOrganizationDetails, any, IOrganizationDetails>;
  errors: FieldErrors<IOrganizationDetails>;
}) => {
  const t = useTranslations();
  return (
    <>
      <Row align="start">
        <Controller
          name="telephoneExchange"
          control={control}
          rules={{
            validate: (value) =>
              validateEmergencyPhoneNumberIfExists(value) ||
              validatePhoneNumberIfExists(value),
          }}
          render={({ field }) => (
            <TextInput
              inputRef={field.ref}
              label={t("Organizations:telephone_exchange_number")}
              placeholder="+46123456789"
              description={
                !errors.telephoneExchange
                  ? t("Common:telephone_placeholder")
                  : undefined
              }
              value={field.value}
              onChange={field.onChange}
              validationError={
                errors?.telephoneExchange &&
                t("Errors:ValidationHint_TelephoneNumber")
              }
            />
          )}
        />
        <Spacer size={32} />
        <Controller
          name="telephoneDirect"
          control={control}
          rules={{
            validate: (value) =>
              validateEmergencyPhoneNumberIfExists(value) ||
              validatePhoneNumberIfExists(value),
          }}
          render={({ field }) => (
            <TextInput
              inputRef={field.ref}
              label={t("Organizations:direct_telephone_number")}
              placeholder="+46123456789"
              description={
                !errors.telephoneDirect
                  ? t("Common:telephone_placeholder")
                  : undefined
              }
              value={field.value}
              onChange={field.onChange}
              validationError={
                errors?.telephoneDirect &&
                t("Errors:ValidationHint_TelephoneNumber")
              }
            />
          )}
        />
      </Row>
      <Spacer size={16} />

      <TwoColGrid>
        <Controller
          name="telephoneMobile"
          control={control}
          rules={{
            validate: (value) =>
              validateEmergencyPhoneNumberIfExists(value) ||
              validatePhoneNumberIfExists(value),
          }}
          render={({ field }) => (
            <TextInput
              inputRef={field.ref}
              label={t("Organizations:mobile_telephone_number")}
              placeholder="+46123456789"
              description={
                !errors.telephoneMobile
                  ? t("Common:telephone_placeholder")
                  : undefined
              }
              value={field.value}
              onChange={field.onChange}
              validationError={
                errors?.telephoneMobile &&
                t("Errors:ValidationHint_TelephoneNumber")
              }
            />
          )}
        />
      </TwoColGrid>
    </>
  );
};
